import { createTheme } from '@mantine/core';
import type { ThemeBundle } from '../types';

const theme = createTheme({
  colors: {
    brand: [
      '#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6',
      '#42a5f5', '#2196f3', '#1e88e5', '#1976d2',
      '#1565c0', '#0d47a1',
    ],
    accent: [
      '#fff3e0', '#ffe0b2', '#ffcc02', '#ffb74d',
      '#ffa726', '#ff9800', '#fb8c00', '#f57c00',
      '#ef6c00', '#e65100',
    ],
  },
  primaryColor: 'brand',
  fontFamily: 'Inter, system-ui, sans-serif',
  headings: { fontFamily: 'Inter, system-ui, sans-serif' },

  white: '#ffffff',
  black: '#1a1b1e',

  defaultRadius: 'md',
  autoContrast: true,
  respectReducedMotion: true,

  components: {
    Modal: {
      defaultProps: {
        overlayProps: { backgroundOpacity: 0.55, blur: 3 },
        transitionProps: { transition: 'fade', duration: 200 },
      },
    },
  },
});

export const baselineBundle: ThemeBundle = {
  key: 'baseline',
  theme,
};
